export default __webpack_public_path__ + "static/media/caro_pic.f5dede60.png";